import React, { useEffect, useState } from 'react';
import { connect } from "react-redux";
import moment from 'moment';
import { openTicket, transactionStatus, setOpenTicketStatus } from '../../../redux/actions/RegisterActions';

import { Panel, PanelBody, PanelHeader } from "../../header/panel/panel"

// Fields that represent money amounts and should be prefixed with $
const MONEY_FIELDS = ['amount', 'cashBack', 'cashBackAmount', 'surcharge', 'surchargeAmount', 'fee', 'feeAmount', 'totalAmount', 'balanceAmount', 'availableBalance', 'requestedAmount', 'approvedAmount']

// Fields to hide from the generic receipt body (shown elsewhere or noise)
const HIDDEN_FIELDS = ['registerId', 'registerID', 'transactionId', 'transactionID']

const prettifyLabel = (key) => {
    const withSpaces = key
        .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
        .replace(/[_-]+/g, ' ')
    return withSpaces.charAt(0).toUpperCase() + withSpaces.slice(1)
}

const formatValue = (key, value) => {
    if (value === null || value === undefined || value === '') {
        return '-'
    }
    if (MONEY_FIELDS.includes(key) && !isNaN(value)) {
        return '$' + Number(value).toFixed(2)
    }
    return String(value)
}

const ReceiptRow = ({ label, value }) => (
    <div className="d-flex justify-content-between" style={{ padding: '2px 0' }}>
        <span>{label}</span>
        <span className="text-end"><b>{value}</b></span>
    </div>
)

const isObject = (value) => value !== null && typeof value === 'object'

// Renders a nested object/array (e.g. EMV tag data) as an indented sub-list
const ReceiptSection = ({ label, value }) => {
    const entries = Array.isArray(value)
        ? value.map((item, index) => isObject(item) && item.tag !== undefined
            ? [item.tag, item.value !== undefined ? item.value : '']
            : [String(index + 1), isObject(item) ? JSON.stringify(item) : item])
        : Object.entries(value)

    return (
        <div style={{ padding: '2px 0' }}>
            <div><b>{label}</b></div>
            <div style={{ paddingLeft: '12px' }}>
                {entries.length ? entries.map(([k, v]) => (
                    <ReceiptRow key={k} label={k} value={formatValue(k, v)} />
                )) : <div className="text-muted">-</div>}
            </div>
        </div>
    )
}

const Divider = () => (
    <div style={{ borderTop: '1px dashed #999', margin: '8px 0' }} />
)

const TransactionStatusPage = (props) => {

    const [tranResponse, setTranResponse] = useState(null)

    useEffect(() => {
        let body = {}

        if (props.REGISTERREDUCER.registerID) {
            body.registerId = props.REGISTERREDUCER.registerID
        }
        if (props?.transactionID) {
            body.transactionId = props?.transactionID
            console.log('tran ID : ', props?.transactionID)

            props.transactionStatus(body, props.REGISTERREDUCER?.registerData[0]?.registerAccessToken)
            props.setOpenTicketStatus(false)
        }

    }, [])

    useEffect(() => {
        setTranResponse(props.REGISTERREDUCER.transactionResponse)
        console.log('tran resp : ', props.REGISTERREDUCER.transactionResponse)
    }, [props.REGISTERREDUCER])

    const register = props.REGISTERREDUCER?.registerData && props.REGISTERREDUCER.registerData.length ? props.REGISTERREDUCER.registerData[0] : null
    const response = tranResponse && !Array.isArray(tranResponse) ? tranResponse : null

    // Remaining response fields not already rendered explicitly
    const detailEntries = response
        ? Object.entries(response).filter(([key]) => !HIDDEN_FIELDS.includes(key))
        : []

    return (

        <div>
            <Panel>
                <PanelHeader>
                    Transaction Status
                </PanelHeader>
                <PanelBody>

                    <div className="fs-13px mx-auto" style={{ maxWidth: '360px', fontFamily: 'monospace' }}>

                        <div className="text-center">
                            <b style={{ fontSize: '15px' }}>{register?.merchantName || 'MERCHANT'}</b>
                            <div>{register?.registerName || ''}</div>
                            <div>Register #{props.REGISTERREDUCER?.registerID}</div>
                        </div>

                        <Divider />

                        <ReceiptRow label="Transaction ID" value={props.transactionID || '-'} />
                        <ReceiptRow label="Date" value={moment().format('MMM DD, YYYY hh:mm:ss A')} />

                        {response ? (
                            <>
                                <Divider />
                                {detailEntries.length ? detailEntries.map(([key, value]) => (
                                    isObject(value)
                                        ? <ReceiptSection key={key} label={prettifyLabel(key)} value={value} />
                                        : <ReceiptRow key={key} label={prettifyLabel(key)} value={formatValue(key, value)} />
                                )) : (
                                    <div className="text-center text-muted">No response details available</div>
                                )}
                            </>
                        ) : (
                            <>
                                <Divider />
                                <div className="text-center text-muted">Fetching transaction status...</div>
                            </>
                        )}

                        <Divider />

                        <div className="text-center text-muted">
                            *** Thank You ***
                        </div>

                    </div>

                </PanelBody>
            </Panel>


        </div>
    )

}
function mapStateToProps(state) {
    return state
}

const mapDispatchToProps = {
    openTicket,
    transactionStatus,
    setOpenTicketStatus

}


export default connect(mapStateToProps, mapDispatchToProps)(TransactionStatusPage);
